const initState = {};

const reducer = (state = initState) => {
	return state;
};

export default reducer;
